import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Babete</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to Babete's marketing platform to continue managing your campaigns." />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="404 - Page Not Found | Babete" />
        <meta property="og:description" content="The page you're looking for doesn't exist on Babete." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="404 - Page Not Found" />
        <meta name="twitter:description" content="This page doesn't exist on Babete." />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-muted/20">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">404</h1>
          <p className="text-xl text-muted-foreground mb-4">Oops! Page not found</p>
          <a href="/dashboard" className="text-primary hover:text-primary/80 underline">
            Return to Home
          </a>
        </div>
      </div>
    </>
  );
};

export default NotFound;
